export const artiQAcceptabilityStatus = {
  ACCEPTABLE: "Acceptable",
  USABLE: "Usable",
  REJECTED: "Rejected",
};

export type SpirometryGrade = "A" | "B" | "C" | "D" | "E" | "F" | "U";

export type SpirometryGradeTagVariant =
  | "success"
  | "warning"
  | "errorLight"
  | undefined;

export function getSpirometryGradeTagVariant(
  grade: string | undefined | null
): SpirometryGradeTagVariant {
  switch (grade) {
    case "A":
      return "success";
    case "B":
    case "C":
      return "warning";
    case "D":
    case "E":
    case "F":
    case "U":
      return "errorLight";
    default:
      return undefined;
  }
}
